import i18next from '../../config/i18next';

i18next.addResources('es', 'CreatePassword', {
  Email: 'Email',
  Save: 'Guardar',
  NewPassword: 'Nueva contraseña',
  RepeatNewPassword: 'Repetir nueva contraseña',
  PasswordConditions: 'La contraseña debe contar con:',
  ConditionOne: 'Al menos 10 caracteres.',
  ConditionTwo: 'Máximo de 16 caracteres.',
  ConditionThree: 'Al menos un caracter especial ( !,#,.,?,-,_,$,&,¡,¿,*).',
  ConditionFour: 'Al menos un dígito entre 0 y 9.',
  ConditionFive: 'No puede contener la palabra "pickit".',
  ConditionSix: 'Al menos una letra mayúscula.',
  ConditionSeven: 'Al menos una letra minúscula.',
  ConditionEight: 'No puede contener el nombre.',
  ConditionNine: 'No puede contener el apellido.',
  onSuccessTitle: 'Cambio de contraseña exitoso',
  onSuccessMessage: 'Se envió un email con la confirmación de esta acción',
});

export default i18next;
